import { createAction, props } from "@ngrx/store";
import { IBaseSearchRequest } from "src/app/core/models/base";
import { ICreateProductRequest, IProduct, IUpdateProductRequest } from "src/app/products/models/product";

// Get Products
export const getProducts = createAction(
    '[Products] Get Products',
    props<{ request: IBaseSearchRequest }>()
);

export const getProductsSuccess = createAction(
    '[Products] Get Products success', 
    props<{ products: IProduct[], total: number }>()
);

export const getProductsFailure = createAction(
    '[Products] Get Products failure',
    props<{error: string}>()
);

// Create Product
export const createProduct = createAction(
    '[Products] Create Product',
    props<{ product: ICreateProductRequest }>()
);

export const createProductSuccess = createAction(
    '[Products] Create Product success',
    props<{ product: IProduct }>()
);

export const createProductFailure = createAction(
    '[Products] Create Product failure',
    props<{error: string}>()
);

// Import Products
export const importProducts = createAction(
    '[Products] Import Wearing Parts',
    props<{ csv: FormData }>()
);

export const importProductsSuccess = createAction(
    '[Products] Import Products success',
    props<{ products: IProduct[] }>()
);

export const importProductsFailure = createAction(
    '[Products] Import Products failure',
    props<{error: string}>()
);

// Update Product
export const updateProduct = createAction(
    '[Products] Update Product',
    props<{ product: IUpdateProductRequest }>()
);

export const updateProductSuccess = createAction(
    '[Products] Update Product success',
    props<{ product: IProduct }>()
);

export const updateProductFailure = createAction(
    '[Products] Update Product failure',
    props<{error: string}>()
);

// Delete Product
export const deleteProduct = createAction(
    '[Products] Delete Product',
    props<{id: string}>()
);

export const deleteProductSuccess = createAction(
    '[Products] Delete Product success',
    props<{id: string}>()
);

export const deleteProductFailure = createAction(
    '[Products] Delete Product failure',
    props<{error: string}>()
);